module.exports = __webpack_public_path__ + "static/media/filter_arrow.edc231a9.svg";